import { DataModel, DataModelBuilder, SerializationContext, SerializedData } from '../../models/dto/dto.js';
import { MapUtils } from '../../utility/map-utils.js';
import { Component } from '../core/component.js';

/**
 * @deprecated Use `SeatingSettingsComponent' instead.
 */
export class LegacySeatingSettingsComponent extends Component {
  static readonly TYPE_ID: string = '95a725f15f1c44b49eb9cd0b9e3b61bc';

  constructor(
    public readonly seatingLayoutId: string,
  ) {
    super();
  }

  get $removable(): boolean {
    return false;
  }

  get $typeId(): string {
    return LegacySeatingSettingsComponent.TYPE_ID;
  }

  static fromMap(context: SerializationContext, map: SerializedData): LegacySeatingSettingsComponent {
    return new LegacySeatingSettingsComponent(
        MapUtils.get<string>(map, 'seatingLayoutId'),
    );
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      'seatingLayoutId': this.seatingLayoutId,
    };
  }

  clone(): this {
    return new LegacySeatingSettingsComponent(
        this.seatingLayoutId,
    ) as this;
  }

  isSame(other: LegacySeatingSettingsComponent): boolean {
    if(this === other) {
      return true;
    }

    return other.seatingLayoutId == this.seatingLayoutId;
  }

  static verifyType(order: DataModel): boolean {
    return order instanceof LegacySeatingSettingsComponent;
  }

  static assertType(order: DataModel): order is LegacySeatingSettingsComponent {
    return order instanceof LegacySeatingSettingsComponent;
  }
}

export class LegacySeatingSettingsComponentBuilder extends DataModelBuilder<LegacySeatingSettingsComponent> {
  build(context: SerializationContext, map: SerializedData): LegacySeatingSettingsComponent {
    return LegacySeatingSettingsComponent.fromMap(context, map);
  }
}
